import { isDefined } from '@sgme/fp';
import { format, isValid } from 'date-fns';
import { useIntl } from 'react-intl';

type FormattedFXDateProps = {
  value?: string | number | Date;
  dateStyle?: 'short' | 'medium' | 'full';
  withHours?: boolean;
};

export const FormattedFXDate = (props: FormattedFXDateProps) => {
  const { value: dateSource, dateStyle = 'medium', withHours = false } = props;

  const { locale } = useIntl();

  const date = isDefined(dateSource)
    ? typeof dateSource === 'string'
      ? /^\d{4}-\d{2}-\d{2}$/.test(dateSource)
        ? new Date(+dateSource.slice(0, 4), +dateSource.slice(5, 7) - 1, +dateSource.slice(8, 10))
        : Date.parse(dateSource)
      : typeof dateSource === 'number'
        ? new Date(dateSource)
        : dateSource
    : undefined;

  const dateFormat =
    withHours && locale === 'en'
      ? dateStyle === 'short'
        ? 'dd/MM/yy h:mm a'
        : dateStyle === 'medium'
          ? 'dd MMM yyyy h:mm a'
          : 'dd MMMM yyyy h:mm a'
      : withHours
        ? dateStyle === 'short'
          ? 'dd/MM/yy HH:mm'
          : dateStyle === 'medium'
            ? 'dd MMM yyyy HH:mm'
            : 'dd MMMM yyyy HH:mm'
        : dateStyle === 'short'
          ? 'dd/MM/yy'
          : dateStyle === 'medium'
            ? 'dd MMM yyyy'
            : 'dd MMMM yyyy';

  return isDefined(date) && isValid(date) ? format(date, dateFormat) : null;
};
